var map = {
	"./banner_article.jpg": "7b77",
	"./banner_full.jpg": "096f",
	"./banner_half.jpg": "6f21",
	"./bsp_cat_1.jpg": "0788",
	"./bsp_cat_2.jpg": "2903",
	"./sidebar_img.jpg": "073c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "28ba";